import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import TopBar from '../elements/TopBar';
import GameTopBar from '../elements/GameTopBar';
import TitleBar from '../elements/TitleBar';
import BudgetHeader from './StepThree/BudgetHeader';
import PopUp from "./PopUp";
import {__} from "i18n-for-browser";

class Header extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({}).isRequired,
    buttonType: PropTypes.string,
    viewType: PropTypes.string,
    showTitle: PropTypes.bool,
    showGameTopBar: PropTypes.bool,
  };
  static defaultProps = {
    showTitle: true,
    desktop: false,
    showGameTopBar: true,
    showBudget: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { props } = this;
    return (
      <div>
        {
          props.desktop ?
            <div>
              <header history={this.props.history}>
                <TopBar/>
                { this.props.showTitle ? (
                  <div className={"desktop-title"}>
                    <div className={"desktop-title-container"}>
                      <TitleBar/>
                    </div>
                  </div>
                ) : null }
                {
                  (this.props.showGameTopBar)
                     ? <GameTopBar
                       match={this.props.match}
                       history={this.props.history}
                       buttonType={this.props.buttonType}
                       viewType={this.props.viewType}
                       />
                  : null
                }
                {
                  (this.props.showBudget)
                  ? <BudgetHeader history={this.props.history} desktop={this.props.desktop} />
                  : null
                }
              </header>
              {
                (this.props.historic)
                  ? <div className="historic"/>
                  : null
              }
            </div>
          :
            <div>
              <header history={this.props.history}>
                {
                  (this.props.showGameTopBar)
                    ? <GameTopBar
                      match={this.props.match}
                      history={this.props.history}
                      buttonType={this.props.buttonType}
                      viewType={this.props.viewType}
                    />
                    : null
                }
                {
                  (this.props.showTitle)
                    ? <TitleBar/>
                    : null
                }
                {
                  (this.props.showBudget)
                    ? <BudgetHeader history={this.props.history} desktop={this.props.desktop} />
                    : null
                }
              </header>
              {
                (this.props.historic)
                  ? <div className="historic"/>
                  : null
              }
            </div>
        }
        <div className={'ministry-popup-container'}>
          { ['SUBMITTED', 'PROCESSED'].includes(props.gameStateInput.myState.SIMULATION_SPENDING) && !props.gameState.history ?
            this.props.gameState.currentRound === 4 ?
              <PopUp
                title={__('sim_verdeling_opgeslagen')}
                hideClose={true}
                id={props.gameStateInput.myState.forceUpdate ? 'dlgmstap3verdelingopslaan_4' : 'dlgmstap3verdelingopslaan_3'}
                closePopUpClick={() => {
                  window.location.href = '/portal';
                }}
                customButton={{
                  text: __('sim_terug_naar_startscherm'),
                  action: () => { window.location.href = '/portal'; }
                }}
              />
              : <PopUp
                title={__('sim_verdeling_opgeslagen')}
                hideClose={true}
                id={props.gameStateInput.myState.forceUpdate ? 'dlgmstap3verdelingopslaan_4' : 'dlgmstap3verdelingopslaan_2'}
                closePopUpClick={() => {
                  window.location.href = '/portal';
                }}
                customButton={{
                  text: __('sim_terug_naar_startscherm'),
                  action: () => { window.location.href = '/portal'; }
                }}
              />
            : null
          }
        </div>
      </div>
    );
  }
}

export default connect(({gameState, gameStateInput}) => ({gameState, gameStateInput}))(Header);



// WEBPACK FOOTER //
// ./src/components/elements/Header.js